/**
 * @file Module to create Tab component.
 */

/**
 * Class representing a tab.
 */
export class Tab {

  /**
   * Setup tab properties.
   * @param {Object} data - Tab data.
   * @param {HTMLElement} data.title - Tab title.
   * @param {HTMLElement} data.content - Tab content.
   */
  constructor(data) {
    this.dom = {
      title: data.title,
      content: data.content
    };
  }

  /**
   * Show tab content.
   * @public
   */
  showContent() {
    this.dom.title.classList.add('selected');
    this.dom.content.classList.add('selected');
  }

  /**
   * Hide tab content.
   * @public
   */
  hideContent() {
    this.dom.title.classList.remove('selected');
    this.dom.content.classList.remove('selected');
  }
}
